import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import darken from 'polished/lib/color/darken';
import { visuallyHiddenStyles } from '../../utils/styleHelpers.js';
import { Button } from '../button/index.js';
import { IconClose } from '../icons/generated/Close.js';
import { ALERT_VARIANTS } from './constants.js';
export { ALERT_VARIANTS } from './constants.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { BUTTON_VARIANTS } from '../button/constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "alert__Wrapper",
  componentId: "sc-1nd57i9-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: ", ";\n  padding: ", ";\n  border-radius: ", ";\n\n  line-height: 1.33;\n  color: ", ";\n  text-shadow: ", ";\n\n  > div {\n    align-self: center;\n  }\n\n  a {\n    text-decoration: none;\n    &:hover,\n    &:focus,\n    &:active {\n      text-decoration: underline;\n    }\n  }\n\n  ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.halfSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return "".concat(theme.spacing.halfSpacing, " ").concat(theme.spacing.baseSpacing);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.radii.default;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.primary.contrastTextLight;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.textShadows.default;
}, _ref6 => {
  let {
    theme: {
      colors
    },
    variant
  } = _ref6;
  switch (variant) {
    case ALERT_VARIANTS.ERROR:
      {
        return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          a {\n            color: ", ";\n            &:hover,\n            &:focus,\n            &:active {\n              color: ", ";\n            }\n          }\n        "])), colors.alerts.error, darken(0.7, colors.alerts.error), darken(0.7, colors.alerts.error), darken(0.6, colors.alerts.error));
      }
    case ALERT_VARIANTS.WARNING:
      {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          a {\n            color: ", ";\n            &:hover,\n            &:focus,\n            &:active {\n              color: ", ";\n            }\n          }\n        "])), colors.alerts.warning, darken(0.7, colors.alerts.warning), darken(0.7, colors.alerts.warning), darken(0.6, colors.alerts.warning));
      }
    case ALERT_VARIANTS.INFO:
      {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          a {\n            color: ", ";\n            &:hover,\n            &:focus,\n            &:active {\n              color: ", ";\n            }\n          }\n        "])), colors.alerts.info, darken(0.7, colors.alerts.info), darken(0.7, colors.alerts.info), darken(0.6, colors.alerts.info));
      }
    case ALERT_VARIANTS.SUCCESS:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          a {\n            color: ", ";\n            &:hover,\n            &:focus,\n            &:active {\n              color: ", ";\n            }\n          }\n        "])), colors.alerts.success, darken(0.7, colors.alerts.success), darken(0.7, colors.alerts.success), darken(0.6, colors.alerts.success));
      }
    // no default
  }
});

const InnerContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "alert__InnerContent",
  componentId: "sc-1nd57i9-1"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-basis: 100%;\n"])));
const CloseButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "alert__CloseButton",
  componentId: "sc-1nd57i9-2"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  align-self: flex-start;\n\n  :not(:hover),\n  :not(:active) {\n    &:focus {\n      box-shadow: ", ";\n    }\n  }\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      background: transparent;\n      color: ", " !important;\n    }\n  }\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return "0 0 0 2px ".concat(theme.colors.primary.contrastText);
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.opacities.darkStrong;
});
const ButtonText = /*#__PURE__*/styled.span.withConfig({
  displayName: "alert__ButtonText",
  componentId: "sc-1nd57i9-3"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), visuallyHiddenStyles);
const Alert = /*#__PURE__*/forwardRef(function Alert(_ref9, ref) {
  let {
    children,
    closeButtonText,
    onClose,
    variant = ALERT_VARIANTS.NEUTRAL,
    ...rest
  } = _ref9;
  return /*#__PURE__*/jsx(Wrapper, {
    ref: ref,
    variant: variant,
    ...rest,
    children: /*#__PURE__*/jsxs(InnerContent, {
      children: [/*#__PURE__*/jsx("div", {
        children: children
      }), onClose && /*#__PURE__*/jsxs(CloseButton, {
        variant: BUTTON_VARIANTS.PLAIN,
        onClick: onClose,
        children: [/*#__PURE__*/jsx(IconClose, {
          title: closeButtonText,
          "aria-hidden": true
        }), /*#__PURE__*/jsx(ButtonText, {
          children: closeButtonText
        })]
      })]
    })
  });
});

export { Alert };
